import React, { FC } from "react";
import { ICardEmployee } from "./types";
import { CardTitle } from "./CardTitle";
import { CardQuote } from "./CardQuote";

export const CardEmployee: FC<ICardEmployee> = ({
  name,
  position,
  image,
  quote,
}) => (
  <article className="max-w-96 mx-auto relative w-full h-full">
    {image ? (
      <img
        className="w-full h-full min-h-[512px] sm:min-h-[640px] object-cover rounded-15"
        src={image}
        alt={name}
      />
    ) : (
      <div className="w-full h-full min-h-[512px] sm:min-h-[640px] bg-gray-300 rounded-15 flex items-center justify-center">
        <span className="text-green-dark text-sm md:text-base text-center px-4">
          Немає фото
        </span>
      </div>
    )}

    <CardTitle name={name} position={position} />
    <CardQuote quote={quote} />
  </article>
);
